import * as React from 'react'

type Props = {
  label?: string
  size?: number
}

export default function Loading({ label = 'Loading…', size = 24 }: Props) {
  const border = Math.max(2, Math.round(size / 12))
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 8 }}>
      <span
        aria-hidden
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          border: `${border}px solid rgba(0,0,0,0.08)`,
          borderTopColor: 'rgba(0,0,0,0.35)',
          animation: 'spin 0.8s linear infinite',
        }}
      />
      <span style={{ fontSize: 14, color: '#444' }}>{label}</span>
      <style>
        {`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}
      </style>
    </div>
  )
}